import { createCaseSteps } from "../CaseFormFields";

export default function CaseCreateSidebar({ step, onStepClick }) {
  return (
    <div className="w-[240px] flex-none bg-navy py-7 hidden lg:block font-plexsans">
      <div className="px-7 pb-5 text-[13px] font-medium text-ivory">Create your case</div>
      {createCaseSteps.map((s) => {
        const done = step > s.id;
        const active = step === s.id;
        // Only a step the user has already completed can be jumped back to
        // from here - the fields on a step still ahead of them haven't been
        // filled in (or validated) yet, so skipping there would just show
        // blank/invalid inputs.
        const clickable = done && !!onStepClick;
        return (
          <div
            key={s.id}
            onClick={clickable ? () => onStepClick(s.id) : undefined}
            role={clickable ? "button" : undefined}
            tabIndex={clickable ? 0 : undefined}
            onKeyDown={
              clickable
                ? (e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      onStepClick(s.id);
                    }
                  }
                : undefined
            }
            className={`flex items-center gap-3 px-7 py-3 transition-colors ${
              active ? "bg-[rgba(201,162,106,.15)] border-l-[3px] border-gold" : "border-l-[3px] border-transparent"
            } ${clickable ? "cursor-pointer hover:bg-[rgba(255,255,255,.07)]" : ""}`}
          >
            <div
              className={`w-[22px] h-[22px] rounded-full flex items-center justify-center text-[11px] font-semibold flex-none ${
                done
                  ? "bg-[#3a7d4f] text-ivory"
                  : active
                  ? "bg-gold text-navy"
                  : "bg-[rgba(255,255,255,.12)] text-[rgba(255,253,248,.5)]"
              }`}
            >
              {done ? "✓" : s.id}
            </div>
            <span
              className={`text-[13.5px] leading-tight ${
                active
                  ? "font-semibold text-ivory"
                  : done
                  ? "font-medium text-[rgba(255,253,248,.75)]"
                  : "font-medium text-[rgba(255,253,248,.45)]"
              }`}
            >
              {s.title}
            </span>
          </div>
        );
      })}
    </div>
  );
}
